// extracted by mini-css-extract-plugin
module.exports = {"slider--paginationDesktop":"BoxList_slider--paginationDesktop__0BuN1","slider":"BoxList_slider__j6_R4","rotation":"BoxList_rotation__ISRFM"};